import { apiGet, apiPatch, apiPost, apiPut } from 'core/api/client';
import { asPaginated } from 'core/api/unwrap';
import { endpoints } from 'core/api/endpoints';
import { userConsultationPayload } from 'features/consultations/consultationUtils';

export const userApi = {
  home(config) {
    return apiGet(endpoints.home, config);
  },
  assessment(config) {
    return apiGet(endpoints.assessment, config);
  },
  startAttempt(config) {
    return apiPost(endpoints.startAttempt, {}, config);
  },
  showAttempt(id, config) {
    return apiGet(endpoints.attempt(id), config);
  },
  saveAnswers(id, answers, config) {
    return apiPut(endpoints.saveAnswers(id), { answers }, config);
  },
  submitAttempt(id, config) {
    return apiPost(endpoints.submitAttempt(id), {}, config);
  },
  results(params, config) {
    return apiGet(endpoints.results, { params, ...config }).then(asPaginated);
  },
  result(id, config) {
    return apiGet(endpoints.result(id), config);
  },
  consultationOptions(config) {
    return apiGet(endpoints.consultationOptions, config);
  },
  consultations(params, config) {
    return apiGet(endpoints.consultations, { params, ...config }).then(asPaginated);
  },
  createConsultation(body, config) {
    return apiPost(endpoints.consultations, userConsultationPayload(body), config);
  },
  consultation(id, config) {
    return apiGet(endpoints.consultation(id), config);
  },
  cancelConsultation(id, body, config) {
    return apiPost(endpoints.cancelConsultation(id), body || {}, config);
  },
  withdrawConsent(id, config) {
    return apiPost(endpoints.withdrawConsent(id), {}, config);
  },
  notifications(params, config) {
    return apiGet(endpoints.notifications, { params, ...config }).then(asPaginated);
  },
  unreadCount(config) {
    return apiGet(endpoints.unreadCount, config);
  },
  markNotificationRead(id, config) {
    return apiPatch(endpoints.markNotificationRead(id), {}, config);
  },
  markAllNotificationsRead(config) {
    return apiPatch(endpoints.markAllNotificationsRead, {}, config);
  },
  supportCategories(config) {
    return apiGet(endpoints.supportCategories, config);
  },
  tickets(params, config) {
    return apiGet(endpoints.supportTickets, { params, ...config }).then(asPaginated);
  },
  createTicket(body, config) {
    return apiPost(endpoints.supportTickets, body, config);
  },
  ticket(id, config) {
    return apiGet(endpoints.supportTicket(id), config);
  },
  currentLegal(config) {
    return apiGet(endpoints.legalCurrent, { skipAuth: true, ...config });
  },
  acceptLegal(documentId, config) {
    return apiPost(endpoints.legalAccept, { document_id: documentId }, config);
  },
};
